module.exports = __webpack_public_path__ + "img/Bank.9ff784d6.png";